import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPpday65 } from './pages'

type TIdToPageMapWoofzPpday65 = Record<PageIdWoofzPpday65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPDAY_65: TIdToPageMapWoofzPpday65 = {
  [PageId.SUBSCRIPTIONS_PPDAY_65_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/subscriptions/SubscriptionPpday65'
      ).then((m) => ({
        default: m.SubscriptionsPpday65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/subscriptions/SubscriptionPpday65'
      ),
  },
  [PageId.CHAT_UPSELL_PPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_PPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzPpday65.DOWNLOAD_PPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzPpday65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
